// extracted by mini-css-extract-plugin
module.exports = {"sidebarHamburger":"JFlj1","showHamburger":"vQCEY","sidebarMenuTitle":"Jno+K"};